import React, { useState, useEffect } from "react";
import Headers from "../../Components/HeaderPublic";
import Footer from "../../Components/Footer";
import Spinner from "../../Components/Spinner/Spinner";
import Toast from "../../Components/Toast/Toast";
import ToastError from "../../Components/Toast/ToastError";
import ToastInfo from "../../Components/Toast/ToastInfo";
import API_URL from "../../const";
import { trackMetaEvent } from "../../utils/metaEvents";

export default function FormUsuarios() {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [showToastInfo, setShowToastInfo] = useState(false);
  const [error, setError] = useState(null);
  const [nuevaEmpresa, setNuevaEmpresa] = useState("");
  const token = localStorage.getItem("token");
  const [contactInfo, setContactInfo] = useState({
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    numTelefonico: "",
    email: "",
    empresa: "",
    contrasenia: "",
    confirmPassword: "",
    id_empUserNuevo: 199,
    cargo: "",
  });

  // Añadimos useEffect para asegurar que la página se cargue desde la parte superior
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setPasswordsMatch(contactInfo.contrasenia === contactInfo.confirmPassword);
  }, [contactInfo]);

  const resetToasts = () => {
    setShowToast(false);
    setShowToastError(false);
    setShowToastInfo(false);
    setError(null);
  };

  const mostrarError = (mensaje, tipo = "error") => {
    resetToasts();
    setError(mensaje);
    if (tipo === "info") setShowToastInfo(true);
    else setShowToastError(true);
    setTimeout(() => {
      if (tipo === "info") setShowToastInfo(false);
      else setShowToastError(false);
      setError(null);
    }, 5000);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setContactInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (IsOpenSpinner) return; // evita reenvíos si ya está en progreso

    const camposRequeridos = [
      contactInfo.nombre,
      contactInfo.apellidoPaterno,
      contactInfo.apellidoMaterno,
      contactInfo.email,
      contactInfo.numTelefonico,
      contactInfo.empresa,
      contactInfo.cargo,
      contactInfo.contrasenia,
      contactInfo.confirmPassword,
    ];

    if (camposRequeridos.some((campo) => campo.trim() === "")) {
      mostrarError(
        "Por favor, completa todos los campos obligatorios.",
        "info"
      );
      return;
    }

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!isValidEmail(contactInfo.email)) {
      mostrarError("El correo electrónico no es válido.");
      return;
    }

    if (!passwordsMatch) {
      console.error("Las contraseñas no coinciden");
      mostrarError("Las contraseñas no coinciden");
      return;
    }

    setIsOpenSpinner(true);
    try {
      const response = await fetch(`${API_URL}insertUserNoValid.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          nombre: contactInfo.nombre,
          apellidoPaterno: contactInfo.apellidoPaterno,
          apellidoMaterno: contactInfo.apellidoMaterno,
          email: contactInfo.email,
          empresa: contactInfo.empresa,
          contrasenia: contactInfo.contrasenia,
          id_empUserNuevo: contactInfo.id_empUserNuevo,
          numTelefonico: contactInfo.numTelefonico,
          cargo: contactInfo.cargo,
        }),
      });

      const text = await response.text();
      const startIndex = text.indexOf("[{");
      const jsonResponse =
        startIndex !== -1 ? text.substring(startIndex) : text;

      const responseData = JSON.parse(jsonResponse);
      setSuccessMessage(responseData.mensaje);

      if (response.ok) {
        // Conversión: registro de usuario completado (navegador Pixel + Conversions API).
        trackMetaEvent("CompleteRegistration", {
          email: contactInfo.email,
          phone: contactInfo.numTelefonico,
          customData: { content_name: "Usuario" },
        });

        setContactInfo({
          nombre: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          numTelefonico: "",
          email: "",
          mensaje: "",
          empresa: "",
          cargo: "",
          giro: "",
          puesto: "",
          contrasenia: "",
          confirmPassword: "",
        });
        resetToasts();
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      } else {
        const mensajeError =
          responseData[0]?.error || response.statusText || "Error desconocido";
        console.error("Error del servidor:", mensajeError);
        mostrarError(mensajeError);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      mostrarError("Error de red: " + error.message);
    } finally {
      setIsOpenSpinner(false);
    }
  };

  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}getEmpresas.php`)
      .then((response) => response.text())
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const jsonResponse =
          startIndex !== -1 ? text.substring(startIndex) : text;

        try {
          const responseData = JSON.parse(jsonResponse);
          setSuccessMessage(responseData.mensaje);
          setEmpresas(responseData);
        } catch (error) {
          console.error("Error al analizar JSON:", error);
          mostrarError("Error de formato en la respuesta del servidor");
          setIsOpenSpinner(false);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
        mostrarError(error.statusText || "Error desconocido");
      });
  }, []);

  const [showNewCompanyInput, setShowNewCompanyInput] = useState(false);

  // Estilo CSS para forzar full width en header y footer
  const fullWidthStyle = {
    width: "100vw",
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    overflowX: "hidden",
  };

  return (
    <>
      <div>
        {/* Header de ancho completo */}
        <div style={fullWidthStyle}>
          <Headers />
        </div>
        <section id="register" className="py-8 w-full">
          {showToast && (
            <Toast isOpen={true} title="Éxito" text="Usuario registrado" />
          )}
          {showToastInfo && (
            <ToastInfo isOpen={true} title="Atención" text={error} />
          )}
          {showToastError && (
            <ToastError isOpen={true} title="Error" text={error} type="error" />
          )}
          <Spinner isOpen={IsOpenSpinner}></Spinner>

          {/* Formulario mejorado */}
          <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg overflow-hidden md:max-w-2xl">
            <div className="p-8">
              <div className="text-center mb-8">
                <h1 className="text-4xl font-bold text-blue-800 flex items-center justify-center">
                  <box-icon
                    type="solid"
                    name="user-account"
                    size="lg"
                    color="#1E429F"
                  ></box-icon>
                  <span className="ml-3 text-4xl">Regístrate</span>
                </h1>
                <p className="text-gray-500 mt-2 text-lg">
                  Completa el formulario para crear tu cuenta
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                autoComplete="off"
                className="space-y-6"
              >
                {/* Nombre */}
                <div className="relative">
                  <label
                    htmlFor="nombre"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Nombre
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                      <box-icon name="id-card" color="gray"></box-icon>
                    </span>
                    <input
                      type="text"
                      name="nombre"
                      id="nombre"
                      value={contactInfo.nombre}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      placeholder="Tu nombre"
                      required
                    />
                  </div>
                </div>

                {/* Apellidos (en dos columnas) */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="relative">
                    <label
                      htmlFor="apellidoPaterno"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Apellido paterno
                    </label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="id-card" color="gray"></box-icon>
                      </span>
                      <input
                        type="text"
                        name="apellidoPaterno"
                        id="apellidoPaterno"
                        value={contactInfo.apellidoPaterno}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="Apellido paterno"
                        required
                      />
                    </div>
                  </div>

                  <div className="relative">
                    <label
                      htmlFor="apellidoMaterno"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Apellido materno
                    </label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="id-card" color="gray"></box-icon>
                      </span>
                      <input
                        type="text"
                        name="apellidoMaterno"
                        id="apellidoMaterno"
                        value={contactInfo.apellidoMaterno}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="Apellido materno"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Email y Teléfono en la misma fila */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Email */}
                  <div className="relative">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Correo electrónico
                    </label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="envelope" color="gray"></box-icon>
                      </span>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={contactInfo.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="correo@ejemplo.com"
                        required
                      />
                    </div>
                  </div>

                  {/* Número telefónico */}
                  <div className="relative">
                    <label
                      htmlFor="numTelefonico"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Número telefónico
                    </label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="phone" color="gray"></box-icon>
                      </span>
                      <input
                        type="text"
                        name="numTelefonico"
                        id="numTelefonico"
                        value={contactInfo.numTelefonico}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="+52 (123) 456-7890"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Contraseña y Confirmar Contraseña en la misma fila */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Contraseña */}
                  <div className="relative">
                    <label
                      htmlFor="contrasenia"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Contraseña
                    </label>
                    <div className="flex relative">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="lock-alt" color="gray"></box-icon>
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="contrasenia"
                        id="contrasenia"
                        minLength={8}
                        maxLength={12}
                        value={contactInfo.contrasenia}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="Min. 8 caracteres"
                        required
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      >
                        <box-icon
                          type="solid"
                          name={showPassword ? "show" : "hide"}
                          color="gray"
                        ></box-icon>
                      </button>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      Mínimo 8 y máximo 12 caracteres
                    </p>
                  </div>

                  {/* Confirmar Contraseña */}
                  <div className="relative">
                    <label
                      htmlFor="confirmPassword"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Confirmar contraseña
                    </label>
                    <div className="flex relative">
                      <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                        <box-icon name="check-shield" color="gray"></box-icon>
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="confirmPassword"
                        id="confirmPassword"
                        minLength={8}
                        maxLength={12}
                        value={contactInfo.confirmPassword}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-2 border ${
                          !passwordsMatch ? "border-red-500" : "border-gray-300"
                        } rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors`}
                        placeholder="Confirmar contraseña"
                        required
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2"
                      >
                        <box-icon
                          type="solid"
                          name={showPassword ? "show" : "hide"}
                          color="gray"
                        ></box-icon>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Mensaje de error de contraseñas */}
                {!passwordsMatch && (
                  <div className="mt-1 mb-2">
                    <span className="text-red-500 text-xs block">
                      * Las contraseñas no coinciden
                    </span>
                  </div>
                )}

                {/* Empresa */}
                <div className="relative">
                  <label
                    htmlFor="empresa"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Registra tu empresa
                  </label>
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                      <box-icon
                        name="building"
                        color="#9CA3AF"
                        size="20px"
                      ></box-icon>
                    </span>
                    <input
                      type="text"
                      name="empresa"
                      id="empresa"
                      value={contactInfo.empresa}
                      onChange={handleInputChange}
                      className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                      placeholder="Nombre de la empresa"
                      required
                    />
                  </div>
                </div>

                {/* Cargo */}
                <div className="relative">
                  <label
                    htmlFor="cargo"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Cargo que desempeñas
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 text-gray-500 bg-gray-100 border border-r-0 border-gray-300 rounded-l-lg">
                      <box-icon name="briefcase" color="gray"></box-icon>
                    </span>
                    <input
                      type="text"
                      name="cargo"
                      id="cargo"
                      value={contactInfo.cargo}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      placeholder="Ej. Gerente, Director, etc."
                      required
                    />
                  </div>
                </div>

                {/* Botón de envío */}
                <div className="pt-4">
                  <button
                    type="submit"
                    className="w-full bg-blue-800 hover:bg-blue-900 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center"
                    disabled={IsOpenSpinner}
                  >
                    <box-icon name="send" color="white"></box-icon>
                    <span className="ml-2">Enviar registro</span>
                  </button>
                </div>

                {/* Mensaje de términos y condiciones */}
                <p className="text-xs text-center text-gray-500 mt-4">
                  Al registrarte, aceptas nuestros términos y condiciones y
                  nuestra política de privacidad.
                </p>
              </form>
            </div>
          </div>
        </section>

        {/* Footer de ancho completo */}
        <div style={fullWidthStyle} className="-mb-8">
          <Footer />
        </div>
      </div>
    </>
  );
}
